var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSocials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 22c0-11.59-9.41-21-21-21S1 10.41 1 22s9.41 21 21 21 21-9.41 21-21z",
    fill: "#040810"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 22c0-11.59-9.41-21-21-21S1 10.41 1 22s9.41 21 21 21 21-9.41 21-21z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.93 14.93l14.142 14.142M14.93 29.07l14.142-14.142"
  }))));
}
export default SvgCloseSocials;